module.exports = __webpack_public_path__ + "static/media/37-10.b9f6ceec.mp3";